export const GO_LIVE = 'ui/GO_LIVE';
export const GO_OFF = 'ui/GO_OFF';
export const TOGGLE_BLANK = 'ui/TOGGLE_BLANK';
export const PREVIEW_RESOURCE = 'ui/PREVIEW_RESOURCE';
export const LIVE_RESOURCE = 'ui/LIVE_RESOURCE';
